import {ComponentProps} from 'react'
import StyledAsyncCombobox from "./StyledAsyncCombobox";

export const docProps : ComponentProps<typeof StyledAsyncCombobox> = {}

export default StyledAsyncCombobox;
